import { SERVICE_CODES, type ServiceCatalog } from '@/entities/service-catalog';

export type ServiceCodeOption = {
    code: string;
    description: string;
    label: string;
    added: boolean;
};

// A custom code already in the published list is dropped — the listed description
// wins the clash, since `SERVICE_CODES` never changes underneath a practice's own library.
export function getServiceCodeOptions(
    catalog: Pick<ServiceCatalog, 'customCodes' | 'services'>,
): ServiceCodeOption[] {
    const listedCodes = new Set<string>(SERVICE_CODES.map((entry) => entry.code));
    const usedCodes = new Set<string>(catalog.services.map((service) => service.code));
    const customOptions = catalog.customCodes.filter((custom) => !listedCodes.has(custom.code));

    return [...SERVICE_CODES, ...customOptions]
        .map(({ code, description }) => ({
            code,
            description,
            label: `${code} – ${description}`,
            added: usedCodes.has(code),
        }))
        .sort((a, b) => a.code.localeCompare(b.code));
}
